import EmailExportHtml from '../../app-lite/export/templates/email-export.html';

export function ExportHistoryCtrl (
  $scope,
  $uibModalInstance,
  $translate,
  $uibModal,
  $q,
  company,
  messages,
  workshopAPI
) {
  $scope.company = company;

  $scope.options = {
    start_date : '*',
    end_date : '*'
  };

  $scope.export = function () {
    workshopAPI.get('/invoices/invoice_csv_export_count', [$scope.company.id, $scope.options.start_date, $scope.options.end_date]).then(function(count) {
      if (count) {
        $uibModalInstance.close();
        $uibModal.open({
          templateUrl: EmailExportHtml,
          controller: 'emailInvoiceExportCtrl',
          windowClass: 'md-modal',
          resolve: {
            company () {
              return $scope.company;
            },
            end_date () {
              return $scope.options.end_date;
            },
            limited () {
              return false;
            },
            start_date () {
              return $scope.options.start_date;
            }
          }
        }).result;
      }
      else {
        messages.error($translate.instant('JS_SPACE.MESSAGES.NO_ITEM_TO_EXPORT', {data: $translate.instant('HISTORY_SPACE.HISTORY')}), 'error');
        return $q.reject();
      };
    });
  };

  $scope.cancel = $uibModalInstance.dismiss;
}